"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcFloatMenuEmptyBehavior = void 0;
var common_constants_1 = require("../../../common/constants/common-constants");
var bc_float_menu_constants_1 = require("./bc-float-menu-constants");
var BcFloatMenuEmptyBehavior = (function () {
    function BcFloatMenuEmptyBehavior() {
    }
    BcFloatMenuEmptyBehavior.prototype.createMenuList = function (container) {
        var ul = document.createElement(common_constants_1.BcCommonConstants.UL_TAG);
        ul.setAttribute(common_constants_1.BcCommonConstants.ROLE, 'menu');
        container.appendChild(ul);
        return ul;
    };
    BcFloatMenuEmptyBehavior.prototype.createEmptyContent = function (valuesEmpty) {
        var _a;
        var container = document.createElement(common_constants_1.BcCommonConstants.DIV_TAG);
        container.className = bc_float_menu_constants_1.BcFloatMenuConstansts.BC_FLOAT_MENU_CONTENT_CLASS_EMPTY;
        if (valuesEmpty.title) {
            container.appendChild(this.createLabeledText(common_constants_1.BcCommonConstants.P_TAG, bc_float_menu_constants_1.BcFloatMenuConstansts.BC_FLOAT_MENU_TITLE_EMPTY, valuesEmpty.title));
        }
        if (valuesEmpty.subtitle) {
            container.appendChild(this.createLabeledText(common_constants_1.BcCommonConstants.P_TAG, bc_float_menu_constants_1.BcFloatMenuConstansts.BC_FLOAT_MENU_SUBTITLE_EMPTY, valuesEmpty.subtitle));
        }
        if ((_a = valuesEmpty.buttons) === null || _a === void 0 ? void 0 : _a.length) {
            container.appendChild(this.createButtonsContainer(valuesEmpty.buttons));
        }
        if (valuesEmpty.link) {
            var _b = valuesEmpty.link, url = _b.url, _c = _b.text, text = _c === void 0 ? '' : _c, leftIcon = _b.leftIcon, rightIcon = _b.rightIcon;
            container.appendChild(this.createLinkElement(url, text, leftIcon, rightIcon));
        }
        return container;
    };
    BcFloatMenuEmptyBehavior.prototype.createLabeledText = function (tag, className, text) {
        var element = this.createTextElement(tag, className, text);
        element.setAttribute(common_constants_1.BcCommonConstants.ROLE, "text");
        element.setAttribute(common_constants_1.BcCommonConstants.ARIA_LABEL, text);
        return element;
    };
    BcFloatMenuEmptyBehavior.prototype.createEmptyIcon = function (valuesEmpty) {
        var emptyIconDiv = document.createElement(common_constants_1.BcCommonConstants.DIV_TAG);
        emptyIconDiv.classList.add(bc_float_menu_constants_1.BcFloatMenuConstansts.BC_FLOAT_MENU_ICON_EMPTY);
        if (!valuesEmpty.icon) {
            emptyIconDiv.hidden = true;
            return emptyIconDiv;
        }
        if (valuesEmpty.typeIcon === "icons") {
            var iconElement = document.createElement(common_constants_1.BcCommonConstants.EM_TAG);
            iconElement.className = "".concat(common_constants_1.BcCommonConstants.ICONS_CLASS, " ").concat(valuesEmpty.icon.size, " icon-").concat(valuesEmpty.icon.name);
            iconElement.textContent = typeof valuesEmpty.icon.name === 'string' ? valuesEmpty.icon.name : '';
            emptyIconDiv.appendChild(iconElement);
        }
        else {
            var iconUrl = ['pictograms', 'illustrations', 'strokes', 'logos'].includes(valuesEmpty.typeIcon)
                ? "".concat(bc_float_menu_constants_1.BcFloatMenuConstansts.BC_FLOAT_MENU_URL, "/").concat(valuesEmpty.typeIcon, "/").concat(valuesEmpty.icon.name, ".svg")
                : '';
            var imgElement = document.createElement(common_constants_1.BcCommonConstants.IMG_TAG);
            imgElement.className = "".concat(common_constants_1.BcCommonConstants.ICONS_CLASS, " ").concat(valuesEmpty.icon.size);
            imgElement.src = iconUrl;
            imgElement.alt = typeof valuesEmpty.icon.name === 'string' ? valuesEmpty.icon.name : '';
            emptyIconDiv.appendChild(imgElement);
        }
        return emptyIconDiv;
    };
    BcFloatMenuEmptyBehavior.prototype.createTextElement = function (tag, className, text) {
        return Object.assign(document.createElement(tag), {
            className: className,
            textContent: text
        });
    };
    BcFloatMenuEmptyBehavior.prototype.createButtonsContainer = function (buttons) {
        var buttonsContainer = document.createElement(common_constants_1.BcCommonConstants.DIV_TAG);
        buttonsContainer.classList.add(bc_float_menu_constants_1.BcFloatMenuConstansts.BC_FLOAT_MENU_BUTTONS_EMPTY);
        buttons.forEach(function (_a, index) {
            var text = _a.text, className = _a.className;
            var button = document.createElement(common_constants_1.BcCommonConstants.BUTTON_TAG);
            button.className = className || '';
            button.textContent = text;
            button.role = common_constants_1.BcCommonConstants.BUTTON_TAG;
            button.dataset.index = index.toString();
            buttonsContainer.appendChild(button);
        });
        return buttonsContainer;
    };
    BcFloatMenuEmptyBehavior.prototype.createLinkElement = function (link, text, leftIcon, rightIcon) {
        var containerLink = document.createElement(common_constants_1.BcCommonConstants.DIV_TAG);
        containerLink.className = bc_float_menu_constants_1.BcFloatMenuConstansts.BC_FLOAT_MENU_CONTAINER_LINK_EMPTY;
        var linkElement = document.createElement(common_constants_1.BcCommonConstants.HREF_TAG);
        linkElement.className = "bc-link link-medium" + " " + bc_float_menu_constants_1.BcFloatMenuConstansts.BC_FLOAT_MENU_LINK_EMPTY;
        linkElement.href = link;
        linkElement.role = "link";
        var leftIconElement = leftIcon
            ? "<em class=\"bc-icon bc-2xs\" aria-hidden=\"true\" aria-label=\"".concat(leftIcon, "\">").concat(leftIcon, "</em>")
            : "";
        var textElement = (text === null || text === void 0 ? void 0 : text.trim())
            ? "<u aria-label=\"".concat(text, "\">").concat(text, "</u>")
            : "";
        var rightIconElement = rightIcon
            ? "<em class=\"bc-icon bc-2xs\" aria-hidden=\"true\" aria-label=\"".concat(rightIcon, "\">").concat(rightIcon, "</em>")
            : "";
        linkElement.innerHTML = "".concat(leftIconElement).concat(textElement).concat(rightIconElement);
        containerLink.appendChild(linkElement);
        return containerLink;
    };
    return BcFloatMenuEmptyBehavior;
}());
exports.BcFloatMenuEmptyBehavior = BcFloatMenuEmptyBehavior;
